import {EventEmitter, EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {BeforeSeasonEvaluationEvent} from "@/modules/season/events/BeforeSeasonEvaluationEvent";
import {AfterSeasonEvaluationEvent} from "@/modules/season/events/AfterSeasonEvaluationEvent";
import {Season} from "@/modules/season/entity";
import {BeforeDayEvaluationEvent} from "@/modules/season/events/BeforeDayEvaluationEvent";
import {AfterDayEvaluationEvent} from "@/modules/season/events/AfterDayEvaluationEvent";
import {DayEvaluator} from "@/modules/season/services/DayEvaluator";

@injectable()
export class EndOfSeasonEventSubscriber implements EventSubscriber {
  constructor(
    @inject(EventEmitter) protected em: EventEmitter,
    @inject(DayEvaluator) protected dayEvaluator: DayEvaluator,
  ) {}

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterDayEvaluationEvent, callback: this.onAfterDayEvaluationEvent},
      {event: BeforeDayEvaluationEvent, callback: this.onBeforeDayEvaluationEvent},
    ];
  }

  async onAfterDayEvaluationEvent(event: AfterDayEvaluationEvent): Promise<void> {
    if (event.season.isLastDay) {
      this.dayEvaluator.isEvaluating.value = false;
    }
  }

  async onBeforeDayEvaluationEvent(event: BeforeDayEvaluationEvent): Promise<void> {
    if (event.season.isLastDay) {
      console.debug('start evaluating season');
      await this.em.emitAsync(new BeforeSeasonEvaluationEvent(event.season));

      event.season.current = false;
      await event.season.save();

      const newSeason = new Season();
      newSeason.current = true;
      newSeason.currentDate = event.season.currentDate.add(1, 'day');
      await newSeason.save();

      await Season.unsetCurrent();

      await this.em.emitAsync(new AfterSeasonEvaluationEvent(event.season, newSeason));
      console.debug('end evaluating season');
    }
  }
}